import type { TrackingData, TrackingPage } from '@/hooks/public/usePublicTracking';

/**
 * Which source the tracking page believes about the parts that move.
 *
 * The page loads a snapshot and then polls, and the two have to be combined
 * somewhere. A `??` chain is the obvious way and the wrong one: it reads a
 * poll's explicit `null` as "no answer" and reaches back to the page load for
 * one. So a technician who stopped sharing kept their marker, their route and
 * their countdown on screen for as long as the page stayed open — the exact
 * staleness the backend refuses to serve, reintroduced on the client.
 *
 * Once a poll has landed it is the whole answer, nulls included. The snapshot
 * only seeds the first render, before there is anything else to go on.
 */
export interface MovingParts {
  status: string;
  eta: TrackingData['eta'];
  techLocation: TrackingData['techLocation'];
}

export function movingParts(
  live: TrackingData | undefined,
  page: TrackingPage | undefined,
): MovingParts {
  const source = live ?? page;
  return {
    status: source?.status ?? '',
    eta: source?.eta ?? null,
    techLocation: source?.techLocation ?? null,
  };
}
